if (window.location.pathname.startsWith("/role")) {

    function renumberRoleRows() {
        $('#rolesTableBody tr').each(function (i) {
            $(this).find('.row-num').first().text(i + 1);
        });
    }
    renumberRoleRows();

    function csrfToken() {
        return $("[name=csrfmiddlewaretoken]").val();
    }

    function buildRoleRow(role) {
        const protectedRole = role.name === 'admin';
        const userCount = role.user_count || 0;
        const disabled = userCount > 0 || protectedRole;
        const title = protectedRole
            ? 'The admin role is protected'
            : (userCount > 0 ? 'Reassign users before deleting' : 'Delete role');
        return `
        <tr class="hover:bg-slate-50" data-role-id="${role.id}">
          <td class="px-4 py-4 text-sm text-slate-700 row-num"></td>
          <td class="px-4 py-4">
            <span class="inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset capitalize bg-slate-50 text-slate-700 ring-slate-600/20 role-name">${role.name}</span>
          </td>
          <td class="px-4 py-4 text-sm text-slate-600 role-description">${role.description || '—'}</td>
          <td class="px-4 py-4 text-sm text-slate-700 role-usercount">${userCount}</td>
          <td class="px-4 py-4 text-sm text-slate-500">${(role.created_at || '').slice(0, 10)}</td>
          <td class="px-4 py-4">
            <div class="flex items-center justify-center gap-2">
              <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-slate-200 text-slate-600 hover:bg-slate-50 roleupdate-btn cursor-pointer"
                      title="Edit role"
                      data-id="${role.id}">
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button class="inline-flex items-center justify-center w-8 h-8 rounded-md border border-red-200 text-red-500 hover:bg-red-50 roledelete-btn cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
                      title="${title}"
                      data-id="${role.id}"
                      data-name="${role.name}"
                      ${disabled ? 'disabled' : ''}>
                <i class="bi bi-trash3-fill"></i>
              </button>
            </div>
          </td>
        </tr>`;
    }

    // Add role
    $(document).on('click', '.addrole-btn', function () {
        $.ajax({ url: '/api/role/modal/add', method: 'GET' }).done(function (response) {
            const dialog = new Dialog("Add Role", response.html, { size: "lg" });
            dialog.setButtons([
                { name: "Cancel", dismiss: true },
                {
                    name: "Create Role",
                    class: "bg-green-600 text-white hover:bg-green-700",
                    onClick: function () {
                        const btn = $(this);
                        const loadingBtn = new LoadingButton(btn);
                        loadingBtn.start();
                        const name = ($('#roleName').val() || '').trim();
                        if (!name) {
                            Toast.show("Role name is required", "error", 3000);
                            loadingBtn.stop();
                            return;
                        }
                        $.ajax({
                            url: '/api/role/create',
                            method: 'POST',
                            headers: { "X-CSRFToken": csrfToken() },
                            data: {
                                name: name,
                                description: ($('#roleDescription').val() || '').trim(),
                            }
                        }).done(function (response) {
                            Toast.show("Role created", "success", 3000);
                            dialog.hide();
                            const tbody = $('#rolesTableBody');
                            // Remove "no roles" placeholder if present
                            if (tbody.find('tr').length === 1 && tbody.find('td[colspan]').length) {
                                tbody.empty();
                            }
                            tbody.append(buildRoleRow({ ...response.role, user_count: 0 }));
                            renumberRoleRows();
                        }).fail(function (jqXHR) {
                            Toast.show((jqXHR.responseJSON && jqXHR.responseJSON.error) || "Failed to create role", "error", 4000);
                        }).always(() => loadingBtn.stop());
                    }
                }
            ]);
            dialog.show();
        });
    });

    // Update role
    $(document).on('click', '.roleupdate-btn', function () {
        const roleId = $(this).data('id');
        $.ajax({
            url: '/api/role/modal/update',
            method: 'GET',
            data: { role_id: roleId },
        }).done(function (response) {
            const dialog = new Dialog("Edit Role", response.html, { size: "lg" });
            dialog.setButtons([
                { name: "Cancel", dismiss: true },
                {
                    name: "Save Changes",
                    class: "bg-blue-600 text-white hover:bg-blue-700",
                    onClick: function () {
                        const btn = $(this);
                        const loadingBtn = new LoadingButton(btn);
                        loadingBtn.start();
                        const id = $('#updateRoleId').val();
                        const name = ($('#updateRoleName').val() || '').trim();
                        const description = ($('#updateRoleDescription').val() || '').trim();
                        if (!name) {
                            Toast.show("Role name is required", "error", 3000);
                            loadingBtn.stop();
                            return;
                        }
                        $.ajax({
                            url: '/api/role/update',
                            method: 'POST',
                            headers: { "X-CSRFToken": csrfToken() },
                            data: { role_id: id, name: name, description: description }
                        }).done(function (response) {
                            Toast.show("Role updated", "success", 3000);
                            dialog.hide();
                            const row = $(`tr[data-role-id="${id}"]`);
                            row.find('.role-name').text(response.role.name);
                            row.find('.role-description').text(response.role.description || '—');
                        }).fail(function (jqXHR) {
                            Toast.show((jqXHR.responseJSON && jqXHR.responseJSON.error) || "Failed to update role", "error", 4000);
                        }).always(() => loadingBtn.stop());
                    }
                }
            ]);
            dialog.show();
        });
    });

    // Delete role
    $(document).on('click', '.roledelete-btn', function () {
        if ($(this).is(':disabled')) return;
        const roleId = $(this).data('id');
        const roleName = $(this).data('name');
        const dialog = new Dialog(
            "Delete Role",
            `<div class="p-6"><p class="text-sm text-slate-700">Delete the role <strong>${roleName}</strong>? This cannot be undone.</p></div>`,
            { size: "md" }
        );
        dialog.setButtons([
            { name: "Cancel", dismiss: true },
            {
                name: "Delete",
                class: "bg-red-600 text-white hover:bg-red-700",
                onClick: function () {
                    const btn = $(this);
                    const loadingBtn = new LoadingButton(btn);
                    loadingBtn.start();
                    $.ajax({
                        url: '/api/role/delete',
                        method: 'POST',
                        headers: { "X-CSRFToken": csrfToken() },
                        data: { role_id: roleId }
                    }).done(function () {
                        Toast.show("Role deleted", "success", 3000);
                        dialog.hide();
                        $(`tr[data-role-id="${roleId}"]`).remove();
                        renumberRoleRows();
                    }).fail(function (jqXHR) {
                        Toast.show((jqXHR.responseJSON && jqXHR.responseJSON.error) || "Failed to delete role", "error", 4000);
                    }).always(() => loadingBtn.stop());
                }
            }
        ]);
        dialog.show();
    });
}
